import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Booking links come from the existing service records (Admin → Offers), so the
// owner updates a Square destination in one place. Falls back to the given URL.
export function useOfferLinks(fallbacks) {
  const [links, setLinks] = useState(fallbacks);
  useEffect(() => {
    api.get("/clinic-offers?type=clinical_service").then(({ data }) => {
      const offers = data.offers || [];
      const find = (k) => offers.find((o) => (o.title || "").toLowerCase().includes(k))?.square_appointment_url;
      setLinks((prev) => ({
        investigation: find("investigation") || prev.investigation,
        micro: find("microscopic") || prev.micro,
      }));
    }).catch(() => {});
  }, []);
  return links;
}
